import React, { useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import { isAuth } from "../../../../pages/auth/ProtectedRoute";
import styles from "../../../../styles/mailCenter/deleteTemplateModal.module.scss";
import { useQueryClient } from "react-query";


const DeleteTemplateModal: React.FC<DeleteTemplateModalProps> = ({
  isOpen,
  onClose,
  templateId,
  onDeleteSuccess,
}) => {
  const [loading, setLoading] = useState(false);
  

  const handleDelete = async () => {
    if (!templateId) return;

    setLoading(true);
    try {
      await axios.delete(
        `${process.env.REACT_APP_HOST_API}mail-center/templates/${templateId}`,
        {
          headers: {
            Authorization: `Bearer ${isAuth()}`,
          },
        }
      );
      swal("Success!", "Template deleted successfully!", "success");
      onDeleteSuccess();
      onClose();
    } catch (error) {
      console.error("Error deleting template:", error);
      swal("Error!", "Failed to delete template. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className={styles["modal-overlay"]}>
      <div className={styles["modal-content"]}>
        <h2>Delete Template</h2>
        <p>Are you sure you want to delete this template? This action cannot be undone.</p>
        <div className={styles["modal-actions"]}>
          <button onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button onClick={handleDelete} disabled={loading} className={styles["delete-btn"]}>
            {loading ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteTemplateModal;